// extracted by mini-css-extract-plugin
export default {"AccountsPage":"AccountsPage_AccountsPage__QPgr4"};